






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import { Utils } from "@/core/Utils";

@Component
export default class PerfilCiudadanoListaSolicitudes extends BaseVue {
  @Prop() readonly personaId!: number;
  @Prop() readonly titulo!: string;
  
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp("personaId", "number"),
      new TipoTramiteComponentProp("titulo", "number",false,"Título")
    );
    this.$emit("render", props);
  }
}
